/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from './Button';

// TODO: move LoadingIcon to @one-thd/core-ui-icons
const LoadingIcon = ({ className }) => {
  return (
    <svg className={`sui-animate-spin ${className}`} width="20" height="20" fill="none" viewBox="0 0 24 24">
      <circle className="sui-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="sui-opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
};
LoadingIcon.displayName = 'LoadingIcon';
LoadingIcon.propTypes = {
  className: PropTypes.string
};
LoadingIcon.defaultProps = {
  className: null
};

const LoadingButton = (props) => {
  const {
    children, variant, loading, disabled, ...rest
  } = props;
  const isPrimary = variant === 'primary' || !variant;
  const isSecondary = variant === 'secondary';

  const iconClasses = classNames('sui-absolute sui-mt-2px sui--translate-x-1/2 sui-left-1/2',
    {
      'sui-text-inverse': isPrimary && !disabled,
      'sui-text-subtle': isPrimary && disabled,
      'sui-text-brand': isSecondary && !disabled,
      'sui-text-inactive': isSecondary && disabled
    });

  return (
    <Button loading={loading} variant={variant} disabled={disabled} {...rest}>
      { loading && (
        <span className={iconClasses}>
          <LoadingIcon />
        </span>
      )}
      {children}
    </Button>
  );
};

LoadingButton.displayName = 'LoadingButton';

LoadingButton.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * If true, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If true, the loading indicator is shown.
   */
  loading: PropTypes.bool,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['primary', 'secondary'])
};

LoadingButton.defaultProps = {
  loading: false
};

export { LoadingButton };
